import { call, put, takeLatest } from 'redux-saga/effects';

import {
  LOADING_ROUTE_START,
  LOADING_ROUTE_FINISHED,
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import {
  USERS_FETCH,
  USERS_FETCH_SUCCESS,
  USERS_FETCH_FAILURE,
  USERS_DELETE_USER,
  USERS_DELETE_USER_SUCCESS,
  USERS_DELETE_USER_FAILURE,
  USERS_TOGGLE_ACTIVE_USER_SUCCESS,
  USERS_TOGGLE_ACTIVE_USER_FAILURE,
  USERS_TOGGLE_ACTIVE_USER,
  USER_SAVE,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAILURE,
  USER_FETCH,
  USER_FETCH_SUCCESS,
  USER_FETCH_FAILURE,
} from '../reducers/users.reducer';
import { handleError } from './helper';
import { userApi } from '../services';

function* fetchUsersRequest() {
  try {
    yield put({ type: LOADING_DATA_START });
    yield put({ type: LOADING_ROUTE_START });
    const result = yield call(userApi.fetchUsers);
    yield put({ type: LOADING_ROUTE_FINISHED });
    yield put({ type: USERS_FETCH_SUCCESS, payload: result.data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: USERS_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteUserRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(userApi.deleteUser, { id });
    yield put({ type: USERS_DELETE_USER_SUCCESS, payload: { id } });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: USERS_DELETE_USER_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* toggleUserActiveRequest({ payload: { user } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield put({ type: LOADING_ROUTE_START });
    user.isActive
      ? yield call(userApi.blockUser, { user })
      : yield call(userApi.unblockUser, { user });

    yield put({
      type: USERS_TOGGLE_ACTIVE_USER_SUCCESS,
      payload: { ...user, isActive: !user.isActive },
    });
    yield put({ type: LOADING_ROUTE_FINISHED });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: USERS_TOGGLE_ACTIVE_USER_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* saveUserRequest({ payload: { user } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield put({ type: LOADING_ROUTE_START });
    if (user.id) {
      yield call(userApi.editUser, { user });
    } else {
      yield call(userApi.createNewUser, { user });
      yield put({ type: USERS_FETCH });
    }

    yield put({ type: USER_SAVE_SUCCESS, payload: { ...user } });
    yield put({ type: LOADING_ROUTE_FINISHED });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: USER_SAVE_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* fetchUserRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_ROUTE_START });
    const { data } = yield call(userApi.fetchUser, { id });
    yield put({ type: USER_FETCH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: USER_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_ROUTE_FINISHED });
}

export function* fetchUsers() {
  yield takeLatest(USERS_FETCH, fetchUsersRequest);
}

export function* deleteUser() {
  yield takeLatest(USERS_DELETE_USER, deleteUserRequest);
}

export function* toggleUserActive() {
  yield takeLatest(USERS_TOGGLE_ACTIVE_USER, toggleUserActiveRequest);
}

export function* saveUser() {
  yield takeLatest(USER_SAVE, saveUserRequest);
}

export function* fetchUser() {
  yield takeLatest(USER_FETCH, fetchUserRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/users.saga.js